
import Vue from "vue";
import moment from "moment";
import { getSettlementPeriodType } from "@/utils/settlementPeriod";

export default Vue.extend({
  props: {
    start_date: {
      type: String,
      required: true,
    },
    end_date: {
      type: String,
      required: true,
    },
  },
  computed: {
    summaryType(): string {
      return getSettlementPeriodType(this.start_date, this.end_date);
    },
  },
  methods: {
    formatWithMoment(dateStr: string, format: string): string {
      return moment(dateStr).format(format);
    },
    getWeekNumber(dateStr: string): number {
      return moment(dateStr).week();
    },
    formatDateRange(start_date: string, end_date: string): string {
      const start = moment(start_date);
      const end = moment(end_date);

      const sameYear = start.year() === end.year();
      const sameMonth = sameYear && start.month() === end.month();
      const sameDay = sameMonth && start.date() === end.date();

      if (sameDay) {
        return `${start.format("YYYY년 M월 D일")}`;
      } else if (sameMonth) {
        return `${start.format("YYYY년 M월 D일")} 부터 ${end.format(
          "D일"
        )} 까지`;
      } else if (sameYear) {
        return `${start.format("YYYY년 M월 D일")} 부터 ${end.format(
          "M월 D일"
        )} 까지`;
      } else {
        return `${start.format("YYYY년 M월 D일")} 부터 ${end.format(
          "YYYY년 M월 D일"
        )} 까지`;
      }
    },
  },
});
